import React from "react";

const CallingPhoneIcon = (props) => {
  const { width, height } = props;
  return (
    <svg
      width={width || "24"}
      height={height || "24"}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2241_14828"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="14"
        y="2"
        width="9"
        height="9"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.3535 2H22.8925V10.5328H14.3535V2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_2241_14828)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22.1422 10.5328C21.7652 10.5328 21.4412 10.2498 21.3982 9.86681C21.0192 6.49081 18.3972 3.87081 15.0202 3.49581C14.6092 3.44981 14.3122 3.07981 14.3582 2.66781C14.4032 2.25681 14.7702 1.95381 15.1862 2.00581C19.2642 2.45881 22.4312 5.62181 22.8882 9.69881C22.9342 10.1108 22.6382 10.4818 22.2272 10.5278C22.1992 10.5308 22.1702 10.5328 22.1422 10.5328Z"
          fill="#185CB7"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M18.6024 10.5432C18.2504 10.5432 17.9374 10.2952 17.8674 9.93718C17.5794 8.45718 16.4384 7.31618 14.9604 7.02918C14.5534 6.95018 14.2884 6.55718 14.3674 6.15018C14.4464 5.74318 14.8464 5.47718 15.2464 5.55718C17.3274 5.96118 18.9344 7.56718 19.3394 9.64918C19.4184 10.0572 19.1534 10.4502 18.7474 10.5292C18.6984 10.5382 18.6504 10.5432 18.6024 10.5432Z"
        fill="#185CB7"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.28872 4.08785L3.36127 4.01204C5.28869 2.08444 6.54385 1.57351 7.88307 2.34362C8.2683 2.56515 8.62945 2.87523 9.12054 3.37401L10.6269 4.93603C11.4589 5.84393 11.6481 6.71478 11.3772 7.73465L11.3398 7.86967L11.2984 8.00392L11.097 8.59474C10.666 9.91972 10.846 10.6673 12.3795 12.2004C13.9742 13.7947 14.7186 13.9251 16.1457 13.4264L16.4001 13.338L16.7077 13.2381L16.8423 13.2007C17.9263 12.9115 18.842 13.1423 19.8132 14.1128L21.0269 15.2852L21.3842 15.6366C21.7803 16.0405 22.0421 16.3606 22.2355 16.6989C23.0008 18.0377 22.4893 19.2921 20.5063 21.2677L20.3177 21.4589C20.0216 21.7442 19.745 21.9486 19.3386 22.1416C18.6565 22.4655 17.8506 22.5876 16.9142 22.4573C14.6067 22.1364 11.6802 20.3158 7.97188 16.6085C7.67002 16.3067 7.3809 16.0107 7.10425 15.7205L6.56748 15.1476C1.53762 9.68285 1.09389 6.32588 3.15518 4.2205L3.28872 4.08785ZM7.90641 4.28093C7.58062 3.95973 7.34396 3.76394 7.13532 3.64396C6.67379 3.37856 6.1755 3.49074 5.25329 4.28448L4.96353 4.54334C4.91299 4.59 4.86129 4.63843 4.80838 4.68868L4.47611 5.01231L4.44617 5.04972L4.22091 5.27603C3.67656 5.83204 3.41871 6.51064 3.6409 7.67767C4.00551 9.59269 5.67442 12.1905 9.0324 15.5477C12.5313 19.0456 15.1972 20.7041 17.1208 20.9716C18.2422 21.1276 18.8142 20.856 19.3975 20.2584L19.8424 19.8095C20.051 19.5912 20.2292 19.3933 20.3797 19.2126L20.585 18.9539C21.1097 18.2551 21.1576 17.8358 20.9332 17.4433C20.8479 17.2939 20.7237 17.1302 20.5429 16.93L20.2977 16.671L20.1525 16.5258L18.6213 15.0472C18.1096 14.5753 17.7599 14.5084 17.229 14.65L17.0757 14.6941L16.4414 14.9094C14.6013 15.5037 13.2738 15.2155 11.3189 13.2612C9.29429 11.237 9.05685 9.88537 9.73522 7.93917L9.77874 7.81411L9.89908 7.45153L9.95823 7.22043C10.0631 6.71746 9.94337 6.36677 9.40269 5.82601C9.38043 5.80375 9.35555 5.77866 9.32847 5.7512L7.90641 4.28093Z"
        fill="#185CB7"
      />
    </svg>
  );
};

export default CallingPhoneIcon;
